export default __webpack_public_path__ + "static/media/main-banner1.5dfbf6a2.jpg";